import React, { Component } from 'react';
import Responsive from 'react-responsive';
import { RESPONSE_STATUS } from '../../utils/constants';
import './Referral.css';
import * as util from '../../utils/util';
import * as zenscroll from 'zenscroll';
export default class Referral extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromName: '',
            toName: '',
            fromPhoneNumber: '',
            toPhoneNumber: '',
            showThankYou: false,
            phoneCountryfrom:'US',
            phoneCountryTo:'US',
        };

        this.invite = this.invite.bind(this);
    }

    handleChange = (e) => {
      let output = e.target.value;
      let phoneOutput;
      if (e.target.name === 'fromPhoneNumber' || e.target.name === 'toPhoneNumber') {
          let input = output;
          input = input.replace(/[^0-9]/g, '');

          let area = input.substr(0,3);
          let pre = input.substr(3,3);
          let last = input.substr(6,4);

          if(e.target.name === 'fromPhoneNumber' && this.state.phoneCountryfrom == 'UK' ){
              phoneOutput = output.substr(0, 10);
          }else if(e.target.name === 'toPhoneNumber' && this.state.phoneCountryTo == 'UK' ){
            phoneOutput = output.substr(0, 10);
          }else{
              if (area.length < 3) {
                phoneOutput = "(" + area;
              } else if (area.length === 3 && pre.length < 3) {
                phoneOutput = "(" + area + ") " + pre;
              } else if (area.length === 3 && pre.length === 3) {
                phoneOutput = "(" + area + ") " + pre + "-" + last;
              }
          }
          
          this.setState({ [e.target.name]: phoneOutput });
          return;
      }else if(e.target.name === "phoneCountryfrom"){
          this.setState({
            phoneCountryfrom: ''
          });
      }else if(e.target.name === "phoneCountryTo"){
        this.setState({
          phoneCountryTo: ''
        });
    }

      this.setState({ [e.target.name]: output });
      e.preventDefault();
      e.stopPropagation();
    }

    handleKeyDownPhoneInput = (e) => {
      let key = e.keyCode;
      if (key === 46) {
          let output = e.target.value;
          if (output.slice(-1) === ' ') {
              output = output.substring(0, output.length - 2);
          } else {
              output = output.substring(0, output.length - 1);
          }
          this.setState({ [e.target.name]: output });
      } else if (key === 8) {
          let output = e.target.value;
          let lastChar = output.charAt(output.length - 1);
          if (lastChar === '-' || lastChar === '(' || lastChar === ')') {
              output = output.substring(0, output.length - 1);
          } else if (lastChar === ' ') {
              output = output.substring(0, output.length - 2);
          }
          this.setState({ [e.target.name]: output });
      }
      e.stopPropagation();
  }

    invite() {
        const fromName = this.state.fromName;
        const toName = this.state.toName;
        const fromPhoneNumber = this.state.fromPhoneNumber;
        const toPhoneNumber = this.state.toPhoneNumber;
        // const fromPhone = "+1 " + fromPhoneNumber;
        // const toPhone = "+1 " + toPhoneNumber;

        const fromPhone = `+${util.getCountry(this.state.phoneCountryfrom)} ${fromPhoneNumber}`;
        const toPhone = `+${util.getCountry(this.state.phoneCountryTo)} ${toPhoneNumber}`;
        
        let toFirstName = '';
        let toLastName = '';
        const spaceIndex = toName.indexOf(' ');
        if (spaceIndex === -1) {
            toFirstName = toName;
        } else {
            toFirstName = toName.substr(0, spaceIndex);
            toLastName = toName.substr(spaceIndex + 1);
        }

        if (fromName && toName && fromPhoneNumber && toPhoneNumber) {
            
            fetch('https://api.airtable.com/v0/appZxmIKC13tXjAF0/Table%201', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + process.env.REACT_APP_AIRTABLE_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "fields": {
                        "First Name": toFirstName,
                        "Last Name": toLastName,
                        "Phone": toPhone,
                        "Referred By": fromName,
                        "Referred By Phone": fromPhone
                    }
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({ showThankYou: true },()=>{

                        let anchor = document.getElementById("referral__thank-you-message");

                        // zenscroll.setup(defaultDuration, edgeOffset)
                        zenscroll.to(anchor);

                    });
                } else {
                    alert("There is a problem to send the invite. Please try again.");
                }
            });
        }else{
            alert("Please enter your contact information");
        }
    }

    render() {
        return (
            // refer-outer-container
            <div className = "refer-body">
                <div className="referral-new-area">
                    <img className="referral-new-img" src="/images/thankYou/skincare.png"></img>

                    <div className="referral-new-text">
                        <h1 className="paragraphBold1 navy">Earn $20 in free skincare</h1>
                        <div className="paragraphRegular3 referral-new-text-conten navy">
                            Send friends $20. <br/>
                            Get $20 yourself for the next two orders ($10/order) when your friends<Responsive minWidth={ 767 }><br/></Responsive> make their first purchase. <br/>
                            That’s what best friends do!
                        </div>

                        <div className="referral-new-input-area">
                            <div className="referral-new-input-item">
                                <div className="referral-new-input-title paragraphSemiBold1 navy">From</div>
                                <div className="referral-new-input-conten">
                                    <input name="fromName" onChange={this.handleChange} value={ this.state.fromName }  className="input-refer-style paragraphRegular4" placeholder="Your name" type="text"></input>
                                    <div className="referral-new-input-select-conten">

                                        <div className="select-country-area" style={ this.state.fromPhoneNumber ? {  position: 'absolute', paddingLeft: '10px',height:'43px'} : {display:'none'} }>
                                            <div className="select-country-text" style={{fontSize: '10px', textAlign: 'left', color: '#272D67'}}>+{ util.getCountry(this.state.phoneCountryfrom)} </div>
                                            <select className="select-country-phone" style={{fontSize: '14px',color: '#272D67'}} name="phoneCountryfrom" onChange={this.handleChange}>
                                                <option value="US">US (+1)</option>
                                                <option value="Canada">Canada (+1)</option>
                                                <option value="UK">UK (+44)</option>
                                            </select>
                                            <i style={{color: '#272D67',left: '38px'}} class="fa fa-caret-down fa-lg select-country-array"></i>
                                        </div>
                                        <input style={ this.state.fromPhoneNumber ? {paddingLeft:'56px'} : null } onChange={this.handleChange} onKeyDown={this.handleKeyDownPhoneInput} name="fromPhoneNumber" value={ this.state.fromPhoneNumber } className="input-refer-style paragraphRegular4" placeholder="Your phone number" type="text"></input>
                                    </div>
                                </div>
                            </div>

                            <div className="referral-new-input-item referral-row-margin">
                                <div className="referral-new-input-title paragraphSemiBold1 navy">To</div>
                                <div className="referral-new-input-conten">
                                    <input name="toName" value={ this.state.toName } onChange={this.handleChange} className="input-refer-style paragraphRegular4" placeholder="Friend’s name"></input>
                                    <div className="referral-new-input-select-conten">
                                    <div className="select-country-area" style={ this.state.toPhoneNumber ? {  position: 'absolute', paddingLeft: '10px',height:'43px'} : {display:'none'} }>
                                            <div className="select-country-text" style={{fontSize: '10px', textAlign: 'left', color: '#272D67'}}>+{ util.getCountry(this.state.phoneCountryTo)} </div>
                                                <select className="select-country-phone" style={{fontSize: '14px',color: '#272D67'}} name="phoneCountryTo" onChange={this.handleChange}>
                                                    <option value="US">US (+1)</option>
                                                    <option value="Canada">Canada (+1)</option>
                                                    <option value="UK">UK (+44)</option>
                                                </select>
                                                <i style={{color: '#272D67',left: '38px'}} class="fa fa-caret-down fa-lg select-country-array"></i>
                                            </div>
                                        <input style={ this.state.toPhoneNumber ? {paddingLeft:'56px'} : null } onChange={this.handleChange} value={ this.state.toPhoneNumber } onKeyDown={this.handleKeyDownPhoneInput}  name="toPhoneNumber" className="input-refer-style paragraphRegular4" placeholder="Friend’s phone number" type="text"></input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="referral-submit-area">
                    <button class="new-button-style" onClick={ this.invite } disabled={ this.state.showThankYou }>Invite</button>
                </div>

                {
                    this.state.showThankYou ?
                    <div className="referral__thank-you-message" id="referral__thank-you-message">
                    Thank you for your referral! Your friend will receive a text from us shortly.
                    </div> :
                    null
                }

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/referral/Referral.js